import axios from 'axios';

const calculate = (ramoAtividade, faturamentoAcumuladoAnoAnterior, faturamentoAcumuladoAnoAtual, mesAnoAbertura) => {
  function isProd() {
    return ['www.contabilizei.com.br', 'blog.contabilizei.com.br'].includes(window.location.hostname);
  }

  return axios.post(`https://us-central1-oi-contabilizei${isProd() ? '' : '-test'}.cloudfunctions.net/calculadora/desenquadramento-mei`,{
    ramoAtividade,
    faturamentoAcumuladoAnoAnterior,
    faturamentoAcumuladoAnoAtual,
    mesAnoAbertura
  });
}


export default {
  calculate
}
